import "./App.css";
import WorkPlannerApp from "./components/WorkplannerApp";

function App() {
	return (
		<div className="App">
			<WorkPlannerApp />
		</div>
	);
}

export default App;
